import { useMutation, useQueryClient } from "react-query";
import { Post } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";

interface CreatePackageTemplateBody {
  name: string;
  length: number;
  width: number;
  height: number;
  dimension_unit: string;
  organization_id: string;
}

export default (org_id: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation<any, null, CreatePackageTemplateBody>(
    `package_template_create`,
    async (body: CreatePackageTemplateBody) =>
      Post(`/api/package_template`, await getAccessTokenSilently(), body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`package_templates_${org_id}`]);
      },
    }
  );
};
